import { ref } from 'vue';
import {
  countryCodeIsUnitedStates,
  peekCachedCurrentIpCountryCode,
  resolveCountryCodeFromCurrentIp,
} from '@/utils/ip-country-lookup';

/**
 * 落地美国 NowPay USD 仅当前出口 IP 为 US 时展示。
 * 资料国家码不参与；探测失败 fail-closed（不展示）。
 */
export const US_PAY_IP_GUARD_ENABLED = true;

export const usPayIpAllowed = ref(
  !US_PAY_IP_GUARD_ENABLED || countryCodeIsUnitedStates(peekCachedCurrentIpCountryCode())
);

export function resetUsPayIpAllowed() {
  usPayIpAllowed.value = !US_PAY_IP_GUARD_ENABLED;
}

/**
 * @param {{ forceRefresh?: boolean }} [options]
 * @returns {Promise<boolean>}
 */
export async function resolveIsUsPayIpAllowed({ forceRefresh = false } = {}) {
  if (!US_PAY_IP_GUARD_ENABLED) {
    usPayIpAllowed.value = true;
    return true;
  }
  const countryCode = await resolveCountryCodeFromCurrentIp({ forceRefresh }).catch(() => null);
  const allowed = countryCodeIsUnitedStates(countryCode);
  usPayIpAllowed.value = allowed;
  return allowed;
}
